import { SegmentedButton } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { configs } from '@hero/configs';
import { ORGANIZATION_ROLES, SETTINGS_TAB } from '@hero/constants';
import { useSelectedOrganization } from '@hero/hooks';

const SettingsTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const organization = useSelectedOrganization();

  const settingOptions = [
    {
      value: SETTINGS_TAB.account,
      label: t('account')
    },
    ...(configs.paymentMethods.enabled
      ? [
          {
            value: SETTINGS_TAB.paymentMethods,
            label: t('paymentMethods')
          }
        ]
      : []),
    {
      value: SETTINGS_TAB.branding,
      label: t('branding')
    },
    ...(organization?.role !== ORGANIZATION_ROLES?.user
      ? [
          {
            value: SETTINGS_TAB.users,
            label: t('users')
          }
        ]
      : [])
  ];

  const handleChange = value => {
    const newPath = location.pathname.replace(/\/[^/]+$/, `/${value}`);
    navigate(newPath);
  };

  return (
    <SegmentedButton
      activeTab={location.pathname.split('/').pop()}
      onChange={handleChange}
      updateHash={false}
      withLine
      options={settingOptions}
      size="md"
    />
  );
};

export { SettingsTabs };
